enum Languages {
    English = 1,
    Spanish = 2
}

export class LanguagesEnum_class {
    public static enum = Languages;

    public static readonly enumByText: {[key: string]: number} = {
        'English': 1,
        'Spanish': 2
    }

    public static readonly enumByNumber: {[key: number]: string} = {
        1: 'English',
        2: 'Spanish'
    }
}